import Application from '../../../application'
export default {
    mounted() {
        this.getAllSchools()
    },
    data: () => ({
        currentStep: 1,
        //Schools
        schoolsHeaders: [
            {
                text: 'Región',
                align: 'left',
                value: 'REGION_NAME'
            },
            {
                text: 'Escuela',
                align: 'left',
                value: 'SCHOOL_NAME'
            },
            {
                text: 'Código de Escuela',
                align: 'left',
                value: 'SCHOOL_CODE'
            },
            {
                text: 'Seleccionar',
                align: 'left',
                sortable: false,
                value: 'SCHOOL_CODE'
            },
            {
                text: 'Lista de Candidatos',
                align: 'center',
                sortable: false,
                value: 'SCHOOL_CODE'
            },
            {
                text: 'Estudiantes Certificados',
                align: 'center',
                sortable: false,
                value: 'SCHOOL_CODE'
            }

        ],
        searchSchools: '',
        schoolsLoading: true,
        schools: [],
        selectedSchool: {},
        loader: null,
        loadingAction: false,
        //Students
        studentsHeaders: [
            {
                text: 'Número de Estudiante',
                align: 'left',
                sortable: false,
                value: 'STUDENT_ID'
            },
            {
                text: 'Apellidos',
                align: 'left',
                sortable: false,
                value: 'FULL_LAST_NAME'
            },
            {
                text: 'Nombre',
                align: 'left',
                sortable: false,
                value: 'FIRST_NAME'
            },
            {
                text: 'Grado',
                align: 'left',
                sortable: false,
                value: 'GRADE'
            },
            {
                text: 'Ruta EE',
                align: 'left',
                sortable: false,
                value: 'Ruta_EE'
            },
            {
                text: 'Sexo',
                align: 'left',
                sortable: false,
                value: 'GENDER_DESCRIPTION'
            },
            {
                text: 'Graduado en Mayo',
                align: 'left',
                sortable: false,
                value: 'GRAD_MAY'
            },
            {
                text: 'Graduado en Verano',
                align: 'left',
                sortable: false,
                value: 'GRAD_SUMMER'
            }
        ],
        searchStudents: '',
        studentsLoading: true,
        students: [],
        //Period
        GRADUATION_PERIOD_ID_FK: '',
        gradStudents: [],
        //School Certification
        SchoolCertifications: []
    }),
    watch: {
        loader() {
            const l = this.loader
            this[l] = !this[l]

            setTimeout(() => (this[l] = false), 3000)

            this.loader = null
        }
    },
    methods: {
        getAllSchools() {
            var self = this
            self.schoolsLoading = true
            this.$ajax.get("/GRAD_CANDIDATES/GetAllSchoolsAsync").then(response => {
                self.schools = response.data
                self.schoolsLoading = false
            }).catch(reponse => {
                self.schoolsLoading = false
                self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
            })
        },
        downloadReportProgreso() {
            window.open(Application.BaseUrl + '/ReportingServicesReports/GetGraduadosCertificadosProgresoReport')
        },
        downloadReportCandidatos(props) {
            window.open(Application.BaseUrl + '/ReportingServicesReports/GetGraduadosCandidatosReport?RP_Schools=' + props.item.SCHOOL_CODE)
        },
        downloadReportExcelCandidatos(props) {
            window.open(Application.BaseUrl + '/ReportingServicesReports/GetGraduadosCandidatosReportExcel?RP_Schools=' + props.item.SCHOOL_CODE)
        },
        downloadReportCertificados(props) {
            window.open(Application.BaseUrl + '/ReportingServicesReports/GetGraduadosCertificadosReport?rp_School=' + props.item.SCHOOL_CODE)
        },
        getSchoolCertifications() {
            var self = this
            return new Promise(function (resolve, reject) {
                self.$ajax.get("/CERTIFIED_SCHOOLS/GetSchoolCertifications", { SCHOOL_ID_FK: self.selectedSchool.SCHOOL_ID_FK })
                    .then(response => {
                        self.SchoolCertifications = response.data
                        resolve()
                    }).catch(reponse => {
                        reject()
                    })
            })
        },
        getStudentsTransactionsBySchoolCode() {
            var self = this
            self.studentsLoading = true
            self.$ajax.get("/GRADUATION_PERIOD/GetActivePeriodAsync")
                .then(GraduationPeriod => {
                    self.GRADUATION_PERIOD_ID_FK = GraduationPeriod.data.GRADUATION_PERIOD_ID_PK,
                        self.$ajax.get("/GRAD_CANDIDATES/GetStudentsGradCandidatesBySchoolIdAsync",
                            { SCHOOL_ID_FK: self.selectedSchool.SCHOOL_ID_FK }
                        ).then(response => {
                            console.log(response.data)
                            self.students = response.data
                            self.studentsLoading = false
                        }).catch(reponse => {
                            self.studentsLoading = false
                            self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
                        })
                }).catch(reponse => {
                    self.studentsLoading = false
                    self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
                })

        },
        selectSchool(school) {
            var self = this
            self.selectedSchool = school.item
            self.getSchoolCertifications().then(() => {
                self.selectedSchool = school.item
                self.currentStep = 2
                self.getStudentsTransactionsBySchoolCode()
            }).catch(() => {
                self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
                self.currentStep = 1
            })
        },
        certifyGradCandidates() {
            var self = this
            self.setGradStudents()
            self.loader = 'loadingAction'
            self.loading = true
            //if (self.gradStudents.length) {
            var mensaje = self.gradStudents.length ? 'Por favor confirme la acción solicitada. ¿Seguro que quieres hacer esto?' : 'No ha seleccionado candidatos para graduación. ¿Seguro que quieres certificar con 0 candidatos?';
            self.$root.$confirm('Confirme', mensaje)
                .then(result => {
                    if (result) {
                        self.$ajax.post("/GRAD_CANDIDATES/SaveAndCertify", {
                            gradStudents: self.gradStudents,
                            SCHOOL_CODE: self.selectedSchool.SCHOOL_CODE,
                            SCHOOL_ID_FK: self.selectedSchool.SCHOOL_ID_FK
                        }).then(response => {
                            self.loading = false
                            self.$root.$snackbar("Los datos fueron guardados correctamente.", { color: 'success' })
                            self.getSchoolCertifications().then(() => {

                            }).catch(() => {
                                self.loading = false
                                self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
                                self.currentStep = 1
                            })
                        }).catch(response => {
                            self.$root.$snackbar('Ha ocurrido un error mientras se trataba de guardar los datos.', { color: 'error' })
                        })
                    }
                })
            //}
            //else {
            //    self.$root.$snackbar("No hay estudiantes candidatos ha graduacion seleccionados.", { color: 'info' })
            //}
        },
        saveGradCandidates() {
            var self = this
            self.setGradStudents()
            self.loader = 'loadingAction'
            self.loading = true
            if (self.gradStudents.length || self.gradStudents.length == 0) {
                self.$root.$confirm('Confirme', 'Por favor confirme la acción solicitada. ¿Seguro que quieres hacer esto?')
                    .then(result => {
                        if (result) {
                            self.$ajax.post("/GRAD_CANDIDATES/Save", {
                                gradStudents: self.gradStudents,
                                SCHOOL_CODE: self.selectedSchool.SCHOOL_CODE,
                                SCHOOL_ID_FK: self.selectedSchool.SCHOOL_ID_FK
                            })
                                .then(response => {
                                    self.loading = false
                                    self.$root.$snackbar("Los datos fueron guardados correctamente.", { color: 'success' })
                                })
                                .catch(response => {
                                    self.loading = false
                                    self.$root.$snackbar('Ha ocurrido un error mientras se trataba de guardar los datos.', { color: 'error' })
                                })
                        }
                    })
            }
            else {
                self.$root.$snackbar("No hay estudiantes candidatos ha graduación seleccionados.", { color: 'info' })
            }

        },
        setGradStudents() {
            if (this.GRADUATION_PERIOD_ID_FK == 1)
                this.gradStudents = this.students.filter(student => student.GRAD_MAY == true)
            else if (this.GRADUATION_PERIOD_ID_FK == 2)
                this.gradStudents = this.students.filter(student => student.GRAD_SUMMER == true)
        }
    },
    computed: {
        isMayOpen() {
            return this.GRADUATION_PERIOD_ID_FK == 1
        },
        isSummerOpen() {
            return this.GRADUATION_PERIOD_ID_FK == 2
        },
        isMayCertified() {
            if (this.SchoolCertifications.length == 0)
                return false
            for (var i = 0; i < this.SchoolCertifications.length; i++) {
                if (this.SchoolCertifications[i].GRADUATION_PERIOD_ID_FK == 1)
                    return true
            }
            return false
        },
        isSummerCertified() {
            if (this.SchoolCertifications.length == 0)
                return false
            for (var i = 0; i < this.SchoolCertifications.length; i++) {
                if (this.SchoolCertifications[i].GRADUATION_PERIOD_ID_FK == 2)
                    return true
            }
            return false
        },
        isMayOpenAndNotCertified() {
            return (this.isMayOpen && !this.isMayCertified)
        },
        isSummerOpenAndNotCertified() {
            return (this.isSummerOpen && !this.isSummerCertified)
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/graduados/graduados/script.js